import Vue from "vue";
import Vuei18n from "vue-i18n";

Vue.use(Vuei18n);

export default new Vuei18n({
  // Установка доступных языков и текущей локали
  locale: localStorage.local || "ru",
  fallbackLocale: "ru",

  messages: {
    uz: {
      local: "uz-latn",
      organization: window.MY_CONFIG_EASYQ.nameOrganizationUZ,
      homeBtnOne: "Oldindan navbatga yo'zilish",
      homeBtnTwo: "Elektron chiptani olish",
      one: "Bank Ipak yo'li filiallari",
      backBtn: "ORQAGA",
      empty: "Bo'sh",
      map: "Xarita",
      workingHours: "Ish vaqti",
      monday: "Dushanba",
      tuesday: "Seshanba",
      wednesday: "Chorshanba",
      thursday: "Payshanba",
      friday: "Juma",
      saturday: "Shanba",
      sunday: "Yakshanba",
      search: "Qidirmoq...",
      profile: "Profil",
      prOne: "Mening elektron chiptalarim",
      prTwo: "Mening buyurtmalarim",
      yourTicket: "Sizning chiptangiz",
      yourBoTicket: "Sizning buyurtmangiz",
      number: "Nomer",
      branch: "Filial",
      address: "Manzil",
      service: "Xizmat",
      validUntil: "Yaroqlilik muddati",
      // Ключи для SMS-авторизации
      getSmsCode: "SMS kodini olish",
      confirmAndBook: "Tasdiqlash va bron qilish",
      smsSentTo: "SMS kod quyidagi raqamga yuborildi:",
      changePhone: "Raqamni o'zgartirish",
      enterSmsCode: "SMS kodini kiriting",
      authError: "Tasdiqlash kodi noto'g'ri",
      smsError: "SMS yuborishda xatolik yuz berdi",
      // Данные бронирования
      booking: "Navbatga yo'zilish",
      personalInformation: "Shaxsiy ma'lumot",
      name: "Ism",
      surname: "Familiya",
      email: "E-mail",
      phone: "Telefon",
      bookingData: "Ma'lumotlarni bron qilish",
      choose: "TANLASH",
      date: "Sana",
      time: "Vaqt",
      next: "KEYINGISI",
      successfulBooking: "Buyurtma muvaffaqiyatli qilindi",
      bookingCode: "Buyurtma kodi",
      copied: "Nusxa olindi",
      textClick: "Buyurtma kodini nusxalash uchun bosing!",
      textPlease: "Buyurtmangiz tafsilotlari SMS orqali yuboriladi",
      textWe:
        "Iltimos, buyurtmangiz codini saqlab oling, bankga tashrif qilganingizda bilet ustuniga kiriting",
      textAlready: "Sizda tugallanmagan chipta bor",
      close: "YOPISH",
      eTicket: "Elektron chiptalarim",
      receive: "Qabul qilish",
      deleteBtnET: "ELEKTRON CHIPTANI O'CHIRISH",
      deleteBtnBO: "BUYURTMANI BEKOR KILISH",
      deteleText: "CHIPTA O'CHIRILDI",
      initialData: "Shaxsiy ma'lumotlar",
      bookingDetails: "Rezervasyon ma'lumotlari",
      bookADate: "SANA TANLASH",
      statusYes: "Holat: Faol",
      statusNo: "Holati: Faol emas",
      statusСalled: "Holati: Chaqirilgan",
      statusСlosed: "Holati: Yo'piq",
      information: "Ma`lumot",
      closeText:
        "Hozirda siz elektron chipta ololmaysiz. Iltimos, ish vaqtida qayting.",
      failure: "Xatolik",
      errorSystem: "Tizim xatosi. Iltimos, qaytadan urinib ko'ring.",
      errorNoTime:
        "Kechirasiz, bu vaqtda boshqa joy yo'q. Boshqa vaqtni tanlang.",
      errorLimit: "Sizning raqamingiz bo'yicha limit oshib ketdi.",
    },
    en: {
      local: "en",
      organization: window.MY_CONFIG_EASYQ.nameOrganizationEN,
      homeBtnOne: "Booking",
      homeBtnTwo: "Get an e-Ticket",
      one: "Branches of bank Ipak Yuli",
      backBtn: "BACK",
      empty: "Empty",
      map: "Map",
      workingHours: "Working hours",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      search: "Search...",
      profile: "Profile",
      prOne: "My e-Tickets",
      prTwo: "My bookings",
      yourTicket: "Your e-Ticket",
      yourBoTicket: "Your booking",
      number: "Number",
      branch: "Branch",
      address: "Address",
      service: "Service",
      validUntil: "Valid until",
      // Ключи для SMS-авторизации
      getSmsCode: "Get SMS Code",
      confirmAndBook: "Confirm and Book",
      smsSentTo: "SMS code sent to:",
      changePhone: "Change phone number",
      enterSmsCode: "Enter SMS code",
      authError: "Invalid confirmation code",
      smsError: "Error sending SMS",
      // Booking data
      booking: "Booking",
      personalInformation: "Personal Information",
      name: "Name",
      surname: "Surname",
      email: "E-mail",
      phone: "Phone",
      bookingData: "Booking data",
      choose: "CHOOSE",
      date: "Date",
      time: "Time",
      next: "Next",
      successfulBooking: "Successful booking",
      bookingCode: "Booking code",
      copied: "Copied",
      textClick: "Click to copy the booking code!",
      textPlease:
        "We will send you by SMS about your booking details, where you can find more information",
      textWe: "Please save your booking code for later",
      textAlready: "You have an unfinished ticket",
      close: "CLOSE",
      eTicket: "e-Ticket",
      receive: "RECEIVE",
      deleteBtnET: "DELETE ELECTRONIC TICKET",
      deleteBtnBO: "DELETE RESERVATION",
      deteleText: "DELETED",
      initialData: "Personal data",
      bookingDetails: "Booking details",
      bookADate: "BOOK A DATE",
      statusYes: "Status: Active",
      statusNo: "Status: Inactive",
      statusСalled: "Status: Called",
      statusСlosed: "Status: Сlosed",
      information: "Information",
      closeText:
        "Currently you can't draw an e-Ticket. Please go back an appointment for at work time.",
      failure: "Failure",
      errorSystem: "System error. Please try again.",
      errorNoTime:
        "Sorry, there are no more places at this time. Please choose another time.",
      errorLimit: "Limit exceeded for this phone number.",
    },
    ru: {
      local: "ru",
      organization: window.MY_CONFIG_EASYQ.nameOrganizationRU,
      homeBtnOne: "Предварительная запись на обслуживание",
      homeBtnTwo: "Получить электронный билет",
      one: "Филиалы банка Ипак Йули",
      backBtn: "НАЗАД",
      empty: "Пусто",
      map: "Карта",
      workingHours: "Режим работы",
      monday: "Понедельник",
      tuesday: "Вторник",
      wednesday: "Среда",
      thursday: "Четверг",
      friday: "Пятница",
      saturday: "Суббота",
      sunday: "Воскресенье",
      search: "Поиск...",
      profile: "Профиль",
      prOne: "Мои электронные билеты",
      prTwo: "Мои бронирования",
      yourTicket: "Ваш билет",
      yourBoTicket: "Ваше бронирование",
      number: "Номер",
      branch: "Филиал",
      address: "Адрес",
      service: "Услуга",
      validUntil: "Действительно до",
      // Ключи для SMS-авторизации
      getSmsCode: "Получить код по SMS",
      confirmAndBook: "Подтвердить и записаться",
      smsSentTo: "SMS код отправлен на номер:",
      changePhone: "Изменить номер",
      enterSmsCode: "Введите SMS код",
      authError: "Неверный код подтверждения",
      smsError: "Ошибка при отправке SMS",
      // Персональные данные
      booking: "Бронирование",
      personalInformation: "Персональные данные",
      name: "Имя",
      surname: "Фамилия",
      email: "Почта",
      phone: "Телефон",
      bookingData: "Данные бронирования",
      choose: "ВЫБРАТЬ",
      date: "Дата",
      time: "Время",
      next: "ДАЛЕЕ",
      successfulBooking: "Успешное бронирование",
      bookingCode: "Код бронирования",
      copied: "Скопировано",
      textClick: "Нажмите, чтобы скопировать код бронирования!",
      textPlease:
        "Вы получите SMS о деталях Вашего бронирования, где вы сможете найти дополнительную информацию",
      textWe:
        "Пожалуйста, сохраните ваш код бронирования для ввода в билетный терминал при посещении банка",
      textAlready: "У вас есть незавершеный билет",
      close: "ЗАКРЫТЬ",
      eTicket: "Электронный билет",
      receive: "ПОЛУЧИТЬ",
      deleteBtnET: "УДАЛИТЬ ЭЛЕКТРОННЫЙ БИЛЕТ",
      deleteBtnBO: "УДАЛИТЬ БРОНИРОВАНИЕ",
      deteleText: "УДАЛЕНО",
      initialData: "Персональные данные",
      bookingDetails: "Данные бронирования",
      bookADate: "ЗАБРОНИРОВАТЬ ДАТУ",
      statusYes: "Статус: Активный",
      statusNo: "Статус: Неактивный",
      statusСalled: "Статус: Вызывается",
      statusСlosed: "Статус: Закрыта",
      information: "Информация",
      closeText:
        "В настоящее время вы не можете оформить электронный билет. Пожалуйста, вернитесь в рабочее время.",
      failure: "Ошибка",
      errorSystem: "Системная ошибка. Пожалуйста, попробуйте снова.",
      errorNoTime: "Извините, на это время мест больше нет. Выберите другое.",
      errorLimit: "Превышен лимит записей на этот номер телефона.",
    },
  },
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});
